import { render, staticRenderFns } from "./TaskChartRating.vue?vue&type=template&id=352feb08&scoped=true&"
import script from "./TaskChartRating.vue?vue&type=script&lang=js&"
export * from "./TaskChartRating.vue?vue&type=script&lang=js&"
import style0 from "./TaskChartRating.vue?vue&type=style&index=0&id=352feb08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352feb08",
  null
  
)

export default component.exports